import { HostedApp } from '@components/hosted-app/HostedApp';
import { environment } from '@environment';
import { usePassthroughParams } from '@hooks/usePassthroughParams';
import { Page } from '../Page';
import './ViewPage.scss';
import { useAppUrl } from '@hooks/useAppUrl';
import { GameSiteUrlParams } from '@play-co/svs-consts';
import { useParamsToSearchParams } from '@hooks/useParamsToSearchParams';
import LoadingVideoOverlay from '@components/loading-video-overlay/LoadingVideoOverlay';
import { useEffect, useState } from 'react';
import { mainSuite } from '@services/ServiceFactory';
import { LoadingVideo, LoadingVideoRequestedOpts, SvsNavbarEvent } from '@play-co/svs-navbar';

const predefinedSearchParams = [
  { key: 'iframed', value: '1' },
];

// page param to search param mapping for story links
const storyMapping = {
  [GameSiteUrlParams.WalletAddress]: GameSiteUrlParams.WalletAddress,
  [GameSiteUrlParams.StoryId]: GameSiteUrlParams.StoryId,
  [GameSiteUrlParams.TokenID]: GameSiteUrlParams.TokenID
};

interface ViewPageProps {
  isNFT?: boolean,
  isAi?: boolean
}


// allows empty strings, since empty strings are falsy
function isStrDefined(str: string | null) {
  return typeof str === 'string';
}

export function ViewPage(props: ViewPageProps) {
  const navbarBridge = mainSuite.navbarService;
  const [showLoadingVideo, setShowLoadingVideo] = useState(false);
  const [loadingVideo, setLoadingVideo] = useState<LoadingVideo | string | null>(null);

  // convert page params to search params
  let convertedParams = useParamsToSearchParams(storyMapping);

  if (props.isNFT) {
    convertedParams = [
      ...convertedParams,
      { key: GameSiteUrlParams.Nft, value: 'true'}
    ]
  }

  if (props.isAi) {
    convertedParams = [
      ...convertedParams,
      { key: GameSiteUrlParams.Ai, value: 'true'}
    ]
  }

  // combine search params
  const includedParams = [
    ...convertedParams,
    ...predefinedSearchParams,
  ];

  // combine passthrough params with page's search params
  const searchParamsStr = usePassthroughParams(environment.passthroughParams, includedParams);

  // appUrl override if enabled
  const url = useAppUrl(environment.viewUrl);

  useEffect(() => {

    function onLoadingVideoEvent(opts: LoadingVideoRequestedOpts) {
      if (!opts) { return; }

      if (opts.show) {
        setLoadingVideo(opts.loadingVideo ?? null);
      }
      setShowLoadingVideo(opts.show);
    }

    navbarBridge.on(SvsNavbarEvent.LoadingVideoRequested, onLoadingVideoEvent);

    return () => {
      navbarBridge.off(SvsNavbarEvent.LoadingVideoRequested, onLoadingVideoEvent);
    }
    
  }, [setShowLoadingVideo, navbarBridge, setLoadingVideo])

  // only allow HostedApp to be shown if url and searchParamsStr are defined
  // to prevent loading twice
  return <Page title="Viewer" className="view-page no-scroll"
    hideFooter
    fullHeight
    hideNavbar
    analyticsManualEntryFinal
  >
    { url && isStrDefined(searchParamsStr) && <HostedApp src={`${url}?${searchParamsStr}`} /> }
    <LoadingVideoOverlay
      show={showLoadingVideo}
      video={loadingVideo}
      loop
    />
  </Page>;
}
